import ApiService from './api.service';

/** The slice of a BuildOrchestration that `/buildorchestrations/last-build` returns. */
export type BuildSummary = {
  id: string;
  status: string | null;
  queued_at?: string | null;
  started_at?: string | null;
  completed_at?: string | null;
  executed_by?: string | null;
  scheduled_build?: boolean;
};

export type LastBuild = {
  /** Branch the answer speaks for — DRAFT, PROD or RUTHIE. */
  environment: string;
  last_successful_build_at: string | null;
  last_successful_build: BuildSummary | null;
  /** Most recent build of any status, so a running or failed one can be called out. */
  latest_build: BuildSummary | null;
};

const IN_FLIGHT_STATUSES = ['QUEUED', 'RUNNING'];

export function isBuildInFlight(build?: BuildSummary | null): boolean {
  return !!build?.status && IN_FLIGHT_STATUSES.includes(build.status);
}

/**
 * When the data was last built. Branch-aware on the server: the endpoint reads
 * the branch off the request, so develop mode gets its own build rather than
 * production's.
 */
export async function getLastBuild(): Promise<LastBuild> {
  const data = await ApiService.getInstance().request('GET', '/buildorchestrations/last-build');
  return data as LastBuild;
}
